// Deterministic identity colour (design system 03-components §14; 01-foundations §1.8): the same
// person is the same colour on every screen. Since the label family landed the avatar draws on a
// label slot — `--label-N` with `--label-N-fg` initials, the pair scripts/gen-tokens-css.mjs
// verifies at 4.5:1 in both themes — and no longer borrows a chart series (`--viz-N`), which carries
// no foreground. One hash-to-slot function serves both identities: a person's key here, a project's
// id in `projectLabelSlot` (src/shared/projects.ts), so the two can never drift apart.
import { PROJECT_LABEL_SLOTS, projectLabelSlot } from '../../shared/projects.js';

export { projectLabelSlot };

/** The eight slots of the label family — the same eight a project draws in. */
export const AVATAR_SLOTS = PROJECT_LABEL_SLOTS;

/**
 * 1-based `--label-N` slot for a person's identifier: the subject id where known, else the address
 * or the name. Case-insensitive and trimmed, so the same person keyed two ways still matches; empty
 * keys share slot 1 rather than throwing.
 */
export function avatarSlot(key: string | null | undefined): number {
  const normalised = (key ?? '').trim().toLowerCase();
  if (normalised === '') return 1;
  return projectLabelSlot(normalised);
}
